/*
export function someMutation (state) {
}
*/

import Constants from '../common/Constants';
import languages from "../languages";

export function setWid(state, payload) {
   state.wid = payload;
}

export function setWidStatus(state, payload) {
   state.widgetStatus = payload;
}

export function setWidWebsite(state, payload) {
	let url = payload.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
   	state.widgetWebsite = url;
}

export function setLoading(state, payload) {
   state.isLoading = payload;
}

export function setTimeStamp(state, payload) {
   state.timeStamp = payload;
}

export function setDebug(state, payload) {
   state.debug = payload;
}

export function setModalOpen(state,payload) {
  state.modalOpen = payload;
}

export function setWidgetOptions(state,payload) {
  state.widgetOptions = { ...payload };
}


export function setWidgetLoaded(state,payload) {
  state.isLoaded = payload;
}

export function setWidgetLanguage(state, lang) {
  let t  = Constants.DEFAULT_LANGUAGE;
  if (Object.keys(languages).includes(lang)) {
    t = lang;
  }

  state.t = languages[t];
}